import React, { Component, Fragment } from 'react';
import './HotSpot.css';
import Icon from '../../Icon';
import ProductTile from './ProductTile';
import Overlay from './Overlay';
import { Popover } from 'reactstrap';

class HotSpot extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  isMobile() {
    return (this.state.onTouchStart || 0) > 0;
  }
  render() {
    const { sku, x, y, activeScreen } = this.props;
    const { isOpen } = this.state;
    if (!sku) {
      return null;
    }

    return (
      <Fragment>
        <Overlay
          isOpen={activeScreen === 'sm' && isOpen}
          onClose={() => this.setState({ isOpen: false })}
        >
          <ProductTile sku={sku} />
        </Overlay>

        <Popover
          placement="auto"
          isOpen={activeScreen !== 'sm' && isOpen}
          target={`${sku}-tooltip`}
          boundariesElement={'#frame'}
          offset={50}
          toggle={() => this.toggle()}
          trigger="hover"
        >
          <ProductTile sku={sku} />
        </Popover>
        <div
          key={sku}
          className={`hotspot${isOpen ? ' is-open' : ''} `}
          style={{
            left: x,
            top: y
          }}
          id={`${sku}-tooltip`}
        >
          <div
            onTouchStart={() => {
              this.setState({ onTouchStart: new Date().getTime() }, () =>
                this.toggle()
              );
            }}
          >
            <Icon
              name="base--icons--plus--thin"
              width="20"
              height="20"
              color={'#fff'}
            />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default HotSpot;



// WEBPACK FOOTER //
// ./src/components/content-blocks/LookBook/HotSpot.js